import { useContext, useEffect, useId, useRef, useState } from "react";
import restart_icon from 'url:../../assets/restart.svg'
import play_icon from 'url:../../assets/play.svg';
import pause_icon from 'url:../../assets/pause.svg';
import silence from 'url:../../assets/wtrok/clips/silence.mp3';
import disc from "url:../../assets/wtrok/recordicon.png";
import { Smashable } from "../../components/cursor/Smashable";
import WTROKPROV from "./WTROKPROV";

export interface Clip
{
    key: string;
    url: string;
    title: string;
    artist: string;
}

export function WTROKPLY (props: {}) {
    const context = useContext(WTROKPROV.context);

    const audioRef = useRef<HTMLAudioElement>(new Audio());
    audioRef.current.crossOrigin = "anonymous";
    const [clip, setClip] = useState<Clip|undefined>(undefined);
    const audioTime = useRef(0);
    const audioDuration = useRef(1);
    const [audioFill, setAudioFill] = useState(0);
    const [paused, setPaused] = useState(true);
    const started = useRef(false);
    
    const restartAudio = () => {
        if (audioRef.current === undefined)
                return;
        audioRef.current.currentTime = 0;
        if (!paused)
            audioRef.current.play();
    };

    useEffect(() => {
        setClip(context.clip);
    }, [context.clip]);

    useEffect(() => {
        if (clip !== undefined)
        {
            audioRef.current.src = clip.url;
            audioRef.current.volume = 0.15;
            audioTime.current = 0;
            audioDuration.current = audioRef.current.duration;
            setAudioFill(0);
            if (!started.current)
                return;
            audioRef.current.play();
            if (paused)
                setPaused(false);
        }
        else
        {
            audioRef.current.src = silence;
            audioTime.current = 0;
            audioDuration.current = 1;
            setAudioFill(0);
            setPaused(true);
        }
    }, [clip]);

    const updateAudioTime = () => {
        audioTime.current = audioRef.current.currentTime;
        audioDuration.current = audioRef.current.duration;
        setAudioFill(Math.round(audioTime.current / audioDuration.current * 100));
    };

    const endAudio = () => {
        setClip(undefined);
    };

    const handlePlayPause = () => {
        if (paused)
        {
            started.current = true;
            setPaused(false);
        }
        else
            setPaused(true);
    };

    useEffect(() => {
        if (started.current)
        {
            if (paused)
                audioRef.current.pause();
            else
                audioRef.current.play();
        }
    }, [paused]);

    return (
        <div className='wtrok-ply padding-8 h-box gap-8'>
            <audio 
                ref={audioRef}
                onTimeUpdate={updateAudioTime} 
                onLoadedMetadata={updateAudioTime} 
                onEnded={endAudio}
            />
            <div className="width-64 v-box height-100p center-all">
                <div className="pos-rel width-64 height-64">
                    <img src={disc} className="pos-abs width-64 filter-darken-h" id='wtrokds' />
                    { 
                        clip !== undefined
                        ? <Smashable onSmash={context.clearClip}>
                            <img src={disc} className={"pos-abs width-64 " + (paused ? '' : 'spin-3s')} />
                        </Smashable>
                        : null
                    }
                </div>
            </div>
            <div className="v-box gap-8">
                <div className="font-treb text-12">
                    Now Playing:
                </div>
                {
                    clip !== undefined
                    ? <div className="h-box font-soon gap-8 text-14">
                        <div>"{clip.title}"</div>
                        -
                        <div>{clip.artist}</div>
                    </div>
                    : <div className="h-box font-soon text-14 text-gray-dark">No Disc Loaded</div>
                }

                <div className="h-box gap-4 center-all">
                    <button onClick={handlePlayPause}>
                        <img src={paused ? play_icon : pause_icon} className="width-16 height-16 filter-black" />
                    </button>
                    <div className='width-128 height-16 bg-gray wtrok-ply-bar'> 
                        <div className="wtrok-ply-fill" style={{width: audioFill+"%", height: 16}} />
                    </div>
                    <button onClick={restartAudio}>
                        <img src={restart_icon} className="width-16 height-16 filter-black" />
                    </button>
                </div>
            </div>
        </ div>
    );
}